import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { EvidenceAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useEvidenceGroupById } from 'src/pages/Evidence/evidence.hooks'
import { SubjectContainer } from './Subject.styles'

export const EvidenceContent = ({
  evidenceId,
  caption,
}: {
  evidenceId: string
  caption?: string
}): JSX.Element => {
  const { pageContext } = useParams()
  const { data, isLoading } = useEvidenceGroupById(evidenceId)
  if (!evidenceId) {
    return caption ? (
      <SubjectContainer>
        <span>{`\u2022`}</span>
        {caption}
      </SubjectContainer>
    ) : (
      <></>
    )
  }

  const evidence = data?.getEvidenceGroup()
  if (!caption || isLoading || !data) {
    return <></>
  }
  const url = `/${pageContext}/${EvidenceAbsoluteRoutes.SHOW}/${evidenceId}`

  const docExists = !!evidence?.getId()

  return (
    <SubjectContainer>
      <span>{`\u2022`}</span>
      {docExists ? <Link to={url}>{caption}</Link> : <>{caption}</>}
    </SubjectContainer>
  )
}
